import { makeStyles } from '@material-ui/core/styles';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import React, { useEffect, useState } from 'react';
import {
    ArrayInput, Button, Create, Loading, NumberInput, required,AutocompleteInput, SaveButton, SimpleForm, TextInput, Toolbar, useNotify
} from 'react-admin';
import { FormSpy } from 'react-final-form';
import SimpleFormIterator from '../formIterator/SimpleFormIterator';
import { differentDeZero, get_total_general_vehicule, json, valideTotal } from '../references.js';
import Customer from './Customer';
import OrderFooter from './OrderFooter';

const marginRight ={marginRight:10};
const styleMarque ={marginRight:10,marginLeft:10};

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const  CreateVehiculeOrder =(props,...rest) => {

    const [listFretDisponible, setListFretDisponible] = useState([]);
    const [disabledSaveButton, setDisabledSaveButton] = useState(true);
    const [total, setTotal] = useState(0);
    const [isAlreadyClient, setIsAlreadyClient] = useState(false);
    const [clone, setClone] = useState(null);
    const notify = useNotify();
    const {resource,permissions}=props;

   useEffect(() => {
        if(!localStorage.getItem('fromShow')) {
            localStorage.removeItem('clone');
        }
        localStorage.removeItem('fromShow');

        fetch(process.env.REACT_APP_URL+"/camp/getCampagneByTypeAndStatus?status=ATTENTE&resource="+resource, 
            {   method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data && data.status>310 && data.error){
                notify(data.error+' : '+data.message,'error');
            } else if(data.totalElements===0) {
                notify("Aucune campagne aérien n'est disponible !","warning");
            }else{
                setListFretDisponible(data.content);
            }
        }).catch((e) => {
            notify("Erreur lors du processus de récupération des campagnes !", 'warning')
        });

        setClone(JSON.parse(localStorage.getItem('clone')));
   
    }, []);


    const change = (formValues)=>{
        const total_general=get_total_general_vehicule(formValues);
        setTotal(total_general);
        if(total_general!==0 && !formValues.gratuit_excep) setDisabledSaveButton(false);
        
    }
    
    const deja_client=()=>{
        alert("Déjà client");
    }

    const CustomToolbar = (props) => (
        <Toolbar {...props}  classes={useStyles()}>
            <SaveButton disabled={disabledSaveButton}/>
            <Button label="Déjà client ?" onClick={()=>deja_client()}><AssignmentInd/></Button>
        </Toolbar>
    );

  return (
   
    listFretDisponible.length >0 ?

      <Create {...props} title={"Total : "+total  +" €"}  >
        <SimpleForm  {...props}  submitOnEnter={true}  redirect="show" margin="none"   toolbar={<CustomToolbar />} initialValues={clone? clone:null} >    
        <Customer listFretDisponible={listFretDisponible} permissions={permissions}/> 
    
           <ArrayInput validate={required()} expanded={true} source="lines_colis" fullWidth label="Ajouter les colis"  >
                <SimpleFormIterator >
                <AutocompleteInput source="marque" label="Marque" choices={[
                    { id: 'Peugeot', name: 'Peugeot' },
                    { id: 'Renault', name: 'Renault' },
                    { id: 'Opel', name: 'Opel' },
                    { id: 'Citroën', name: 'Citroën' },
                    { id: 'Volkswagen', name: 'Volkswagen' },
                    { id: 'Ford', name: 'Ford' },
                    { id: 'Mercedes', name: 'Mercedes' },
                    { id: 'BMW', name: 'BMW' },
                    { id: 'Hyundai', name: 'Hyundai' },
                    { id: 'Nissan', name: 'Nissan' },
                    { id: 'Seat', name: 'Seat' },
                    { id: 'Fiat', name: 'Fiat' },
                ]}  validate={required()} />
                    <TextInput source="model"  label="Model"   style={styleMarque} validate={required()}   />           
                    <TextInput source="description"  label="Chassis"   style ={marginRight} validate={required()}   />  
                    <NumberInput  source="prix_unitaire" label="Prix unitaire"   validate={[required()]} style ={marginRight} />
                    <TextInput source="type"  label="Type"   style ={marginRight}   />  
                    <NumberInput  source="poids"   label="Poids"   style={marginRight} />
                    <NumberInput  source="longueur" label="Longueur"  style={marginRight}/>   
                    <NumberInput  source="largeur" label="Largeur"    style ={marginRight} />
                    <NumberInput  source="hauteur" label="Hauteur"  style ={marginRight} />
                    <NumberInput  source="volume" label="Volume"    style ={marginRight} />
                    <TextInput source="status"  label="Status"   style ={marginRight}   />  
                    <TextInput source="date_quai"  label="Date quai"   style ={marginRight}  />  
                    <NumberInput  min="0" source={"total_line"} label="Total" style ={marginRight} />
                    <NumberInput  source="poids" defaultValue={1}   style={{display:'none'}} />
                    <NumberInput  source="quantite" defaultValue={1} style={{display:'none'}}/>   
                </SimpleFormIterator>
            </ArrayInput>
            <OrderFooter />      
            <FormSpy
                onChange={props => {
                    change(props.values);
                }}
            />
        </SimpleForm>
    </Create> :<Loading />
    );
};

export default CreateVehiculeOrder;
